let state = {};
state.danhGia = {
  refreshFnCountNew: 0,
};
state.loiNhan = {
  refreshFnCountNew: 0,
};
state.dangKyDongHo = {
  refreshFnCountNew: 0,
};

export default state;
